<template>
  <VTDropDownPill
    :is-enabled="isEditable"
    :class="$style.wrapper"
    :disable-save-button="!isValidMenuBadgeIcon"
    @on-click-outside="reset()"
    @clear="reset()"
    @confirm="updateOffer()"
  >
    <template #dropDownHeader>
      <InputGroup :class="$style.inputGroup">
        <InputGroupAddon>
          <VdIcon store="fas" name="seal" size="large"></VdIcon>
        </InputGroupAddon>
        <InputText id="badgeMenuIcon" v-model="menuBadge.menuBadgeIcon" :disabled="true" :class="$style.inputText" />
        <InputGroupAddon>
          <VdIcon store="fa" name="pen-to-square" size="large"></VdIcon>
        </InputGroupAddon>
      </InputGroup>
    </template>
    <template #dropdown-content>
      <div :class="$style.container">
        <OfferBadge
          :menu-badge-icon="menuBadge.menuBadgeIcon"
          :display-menu-badge="menuBadge.displayMenuBadge"
          :can-edit-menu-badge-display-count-down="isEditable"
          :can-edit-display-menu-badge="isEditable"
          :show-menu-badge-display-checkbox="isEditable"
          :is-valid-badge-icon="isValidMenuBadgeIcon"
          @update="handleMenuBadgeUpdate"
        />
      </div>
    </template>
  </VTDropDownPill>
</template>

<script setup>
import VTDropDownPill from "@/components/VTDropdownPill";
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import isTrimmedAndNonEmpty from "@/utils/isTrimmedAndNonEmpty";
import InputGroup from "primevue/inputgroup";
import InputGroupAddon from "primevue/inputgroupaddon";
import InputText from "primevue/inputtext";
import { computed, reactive, watch } from "vue";
import OfferBadge from "./OfferBadge.vue";

const props = defineProps({
  menuBadgeIcon: {
    type: String,
    default: "",
  },
  displayMenuBadge: {
    type: Boolean,
    default: false,
  },
  displayCountDownInMenuBadge: {
    type: Boolean,
    default: false,
  },
  isEditable: {
    type: Boolean,
    default: true,
  },
});

const menuBadge = reactive({
  displayCountDownInMenuBadge: props.displayCountDownInMenuBadge,
  displayMenuBadge: props.displayMenuBadge,
  menuBadgeIcon: props.menuBadgeIcon,
});

watch(
  () => props,
  () => {
    reset();
  },
  { deep: true }
);

const emits = defineEmits(["update"]);

function reset() {
  menuBadge.menuBadgeIcon = props.menuBadgeIcon;
  menuBadge.displayCountDownInMenuBadge = props.displayCountDownInMenuBadge;
  menuBadge.displayMenuBadge = props.displayMenuBadge;
}

function updateOffer() {
  const updatedMenuBadge = {
    ...menuBadge,
    menuBadgeIcon: menuBadge.displayMenuBadge ? menuBadge.menuBadgeIcon : "",
  };
  emits("update", updatedMenuBadge);
}

function handleMenuBadgeUpdate(value) {
  menuBadge.menuBadgeIcon = value.menuBadgeIcon;
  menuBadge.displayCountDownInMenuBadge = value.displayCountDownInMenuBadge;
  menuBadge.displayMenuBadge = value.displayMenuBadge;
}

const isValidMenuBadgeIcon = computed(
  () => !menuBadge.displayMenuBadge || isTrimmedAndNonEmpty(menuBadge.menuBadgeIcon)
);
</script>

<style module>
.container {
  padding: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wrapper {
  width: 100%;
}

.inputGroup {
  height: 32px;
}

.inputText {
  border-right: none;
  border-left: none;
  border-top: 1px solid var(--vd-color-neutral-light-2);
  border-bottom: 1px solid var(--vd-color-neutral-light-2);
  opacity: 1;
  font-size: 12px;
  color: var(--vd-color-text-dark);
  padding-left: 0;
}
</style>
